/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useRef } from 'react'
import { Modal } from 'antd-mobile'
import { SERVER_STATE } from '@constants/index'
import { GlobalStoreKey } from '@v2/constants/common'
// css
import { ModalBg } from '@styles/base.style'
import { Button, EventFooter } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { EventModalStyle } from '@styles/modal'
import { isMobile } from 'react-device-detect'
import { NoticeModalWrap } from './index.style'
import StorageUtils from '@utils/storage-utils'
import dayjs from 'dayjs'

const PartnershipBannerPopup: React.FC = props => {
  const { globalStore } = useRootStore()
  const { visiblePartnershipBannerPopup } = globalStore
  const videoRef = useRef<HTMLVideoElement | null>(null)

  const imageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value
  const partnershipBannerImgUrl01 =`${imageUrl}popup/adv_partnership_popup_img_01.jpg?v=${new Date().getTime()}`
  const partnershipBannerImgUrl02 =`${imageUrl}popup/adv_partnership_popup_img_02.jpg?v=${new Date().getTime()}`
  const partnershipBannerImgUrl03 =`${imageUrl}popup/adv_partnership_popup_img_03.jpg?v=${new Date().getTime()}`
  const partnershipBannerMovieUrl =`${imageUrl}popup/adv_partnership_popup_movie_kcc.mp4?v=${new Date().getTime()}`


  if (!visiblePartnershipBannerPopup) {
    return null
  }
  const onCloseModal = () => {
    globalStore.setVisiblePartnershipBannerPopup(false)
  }
  const onCloseHideModal = () => {
    StorageUtils.saveNoticeHide()
    onCloseModal()
  }

  const popupImages = []
  popupImages.push(
    <img src={partnershipBannerImgUrl01} alt="KCC이지스 승부사 온라인, 건전한 응원 문화 동참해주세요. 정준영과 함께하는 건전한 스포츠 응원 캠페인" style={{ width: '100%' }}/>,
  )
  popupImages.push(
    <img src={partnershipBannerImgUrl02} alt="KCC이지스 승부사 온라인, 건전한 응원 문화 동참해주세요. 송교창과 함께하는 건전한 스포츠 응원 캠페인" style={{ width: '100%' }}/>,
  )
  popupImages.push(
    <img src={partnershipBannerImgUrl03} alt="KCC이지스 승부사 온라인, 건전한 응원 문화 동참해주세요. 최준용과 함께하는 건전한 스포츠 응원 캠페인" style={{ width: '100%' }}/>,
  )

  const popupImageIndex = (Math.floor(Math.random() * popupImages.length))

  let elem = (
    <Modal
      transparent
      visible={visiblePartnershipBannerPopup}
      maskClosable={false}
      onClose={onCloseModal}
      css={EventModalStyle}
      className={isMobile ? 'event' : 'event pc'}
      wrapClassName="notice-popup"
    >
      <NoticeModalWrap className="notice-modal-wrap">
        <div className={isMobile ? 'notice-modal-btn' : 'notice-modal-btn pc'}>
          {popupImages[popupImageIndex]}
        </div>

        <video
          className="partnership-video"
          ref={videoRef}
          controls
          muted={true}
          autoPlay={true}
          playsInline={true}
        >
          <source src={partnershipBannerMovieUrl} type="video/mp4"/>
        </video>

        <div css={EventFooter} className="box-type-bottom">
          <input type="checkbox" id="check" onClick={onCloseHideModal}/>
          <label htmlFor="check" className="check-label">
            <span className="check-label-ico">체크</span>
            <span className="check-label-txt">7일 동안 보지 않기</span>
          </label>

          <Button className="event-popup-btn-cls" onClick={onCloseModal}>
            <span className="cls-txt">닫기</span>
          </Button>
        </div>
      </NoticeModalWrap>

      <ModalBg onClick={onCloseModal} className="modal-bg"/>
    </Modal>
  )

  const hideDate = StorageUtils.getNoticeHide()
  if (hideDate) {
    const hideDateToNumber = Number(hideDate)
    if (dayjs().valueOf() < hideDateToNumber) {
      elem = null
    }
  }

  if (globalStore.serverState === SERVER_STATE.OFF) {
    elem = null
  }

  if (!elem) {
    globalStore.setVisiblePartnershipBannerPopup(false)
  }

  return elem
}

export default observer(PartnershipBannerPopup)
